import type { Source } from '@seek/chalice-types';
import { isHomepagePath, isSearchResultsPath } from '@seek/seek-jobs-seo';

const searchEngines = [
  'google',
  'bing',
  'yahoo',
  'duckduckgo',
  'baidu',
  'yandex',
];

const isFromSearchEngine = (referrer: string): boolean =>
  searchEngines.some((engine) => referrer.includes(engine));

export const getSource = ({
  savedSearchId,
  source,
  pathname,
  prevPathname,
}: {
  savedSearchId?: string;
  source?: Source;
  pathname: string;
  prevPathname: string | null;
}): Source | undefined => {
  if (Boolean(savedSearchId)) {
    return 'SAVED';
  }

  // Return existing source if already provided
  if (source) {
    return source;
  }

  const isSearchResultsPage = isSearchResultsPath(pathname);
  if (isSearchResultsPage) {
    const isNavigatingFromHomePage =
      prevPathname && isHomepagePath(prevPathname);

    // User navigated from home page to search results
    if (isNavigatingFromHomePage) {
      return 'FE_HOME';
    }

    if (
      typeof document !== 'undefined' &&
      isFromSearchEngine(document.referrer)
    ) {
      return 'SEARCH_ENG';
    }

    // User is on search results page (from other sources)
    return 'FE_SERP';
  }

  return undefined;
};
